export default __webpack_public_path__ + "static/media/imagem s2pay maq.6403e2b6.png";